import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import {
  DocumentSource,
  DocumentType,
  documentRegistryKey,
  type DocumentKey,
  type DocumentRegistryKey,
} from './types';
import type { DocumentViewerInstanceProps } from './createDocumentViewer';

type ViewerComponent = LazyExoticComponent<
  ComponentType<DocumentViewerInstanceProps<DocumentKey>>
>;

export const REGISTRY: Partial<Record<DocumentRegistryKey, ViewerComponent>> = {
  [documentRegistryKey(DocumentSource.MEDICAL_RECORDS, DocumentType.VITALS)]:
    lazy(
      () => import('./viewers/VitalsRecordsViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_DATA, DocumentType.VITALS)]: lazy(
    () => import('./viewers/VitalsDataViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.LAB_RESULTS,
  )]: lazy(
    () => import('./viewers/LabResultsRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_DATA, DocumentType.LAB_RESULTS)]:
    lazy(
      () => import('./viewers/LabResultsDataViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_RECORDS, DocumentType.PROBLEMS)]:
    lazy(
      () => import('./viewers/ProblemsRecordsViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_DATA, DocumentType.PROBLEMS)]:
    lazy(
      () => import('./viewers/ProblemsDataViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.PROVIDER_NOTES,
  )]: lazy(
    () => import('./viewers/ProviderNotesRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_RECORDS, DocumentType.IMAGING)]:
    lazy(
      () => import('./viewers/ImagingRecordsViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.PROCEDURES,
  )]: lazy(
    () => import('./viewers/ProceduresRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.PATHOLOGY_RESULTS,
  )]: lazy(
    () => import('./viewers/PathologyRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.MEDICATIONS,
  )]: lazy(
    () => import('./viewers/MedicationsRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.ENCOUNTERS,
  )]: lazy(
    () => import('./viewers/EncountersRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.ADDITIONAL,
  )]: lazy(
    () => import('./viewers/AdditionalRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(
    DocumentSource.MEDICAL_RECORDS,
    DocumentType.ORIGINAL_RECORDS,
  )]: lazy(
    () => import('./viewers/OriginalRecordsViewer'),
  ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_DATA, DocumentType.MEDICATIONS)]:
    lazy(
      () => import('./viewers/MedicationsDataViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_DATA, DocumentType.PROCEDURES)]:
    lazy(
      () => import('./viewers/ProceduresDataViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_DATA, DocumentType.ALLERGIES)]:
    lazy(
      () => import('./viewers/AllergiesDataViewer'),
    ) as unknown as ViewerComponent,
  [documentRegistryKey(DocumentSource.MEDICAL_DATA, DocumentType.VACCINATIONS)]:
    lazy(
      () => import('./viewers/VaccinationsDataViewer'),
    ) as unknown as ViewerComponent,
};
